import axios from "axios";
import { apis, serverCall } from "../../../utils/api/constant";
import {
  FETCH_DATA_REQUEST,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_FAILURE,
  SET_SUMMIT,
  GET_DATA_CUSTOMER,
  GET_DATA_CUSTOMER_DETAILS,
  SET_DATA_NOTIFICATION_REMARK,
  CLEAR_ALL_DATA,
  GET_DATA_EVENT,
  _GET_ALL_DETIALS,
} from "./action";
import { logOut } from "../../../Logout";

export const fetchDataServiceMeterCategory = (userData) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      let response = await serverCall(
        apis.FETCH_DATA_CATEGORY,
        "POST",
        {
          userName: userData?.pDATASET[0]?.USERNAME,
          apiID: 1,
          param1: 1,
          param2: 0,
          param3: 0,
          param4: "",
          param5: "",
          param6: "",
        },
        { sid: userData.token }
      );
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
        logOut(response.data); // Run logout function on error
      }
      dispatch({ type: FETCH_DATA_SUCCESS, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

export const setLowBalance = (userData, data) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      let response = await serverCall(
        apis.NOTIFICATIN_REQUEST,
        "POST",
        { userName: userData?.pDATASET[0]?.USERNAME, apiID: 1, data: data },
        { sid: userData.token }
      );
      console.log(response, "response");

      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
        logOut(response.data); // Run logout function on error
      } else {
        dispatch({ type: SET_SUMMIT, payload: response.data });
      }
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

export const setDisconnection = (userData, data) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      let response = await serverCall(
        apis.NOTIFICATIN_REQUEST,
        "POST",
        { userName: userData?.pDATASET[0]?.USERNAME, apiID: 2, data: data },
        { sid: userData.token }
      );
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
        logOut(response.data); // Run logout function on error
      }
      dispatch({ type: SET_SUMMIT, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

export const setHighUsages = (userData, data) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      let response = await serverCall(
        apis.NOTIFICATIN_REQUEST,
        "POST",
        { userName: userData?.pDATASET[0]?.USERNAME, apiID: 3, data: data },
        { sid: userData.token }
      );
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
        logOut(response.data); // Run logout function on error
      }
      dispatch({ type: SET_SUMMIT, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

export const setPaymentAndAdjustment = (userData, data) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      let response = await serverCall(
        apis.NOTIFICATIN_REQUEST,
        "POST",
        { userName: userData?.pDATASET[0]?.USERNAME, apiID: 4, data: data },
        { sid: userData.token }
      );
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
        logOut(response.data); // Run logout function on error
      }
      dispatch({ type: SET_SUMMIT, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

export const setReconnect = (userData, data) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      let response = await serverCall(
        apis.NOTIFICATIN_REQUEST,
        "POST",
        { userName: userData?.pDATASET[0]?.USERNAME, apiID: 5, data: data },
        { sid: userData.token }
      );
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
        logOut(response.data); // Run logout function on error
      }
      dispatch({ type: _GET_ALL_DETIALS, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

export const getCustomer = (userData, consumerNum) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      let response = await serverCall(
        apis.GET_NOTIFICATION_DETAILS,
        "POST",
        {
          userName: userData?.pDATASET[0]?.USERNAME,
          apiID: 2,
          param1: consumerNum,
          param2: 0,
          param3: 0,
          param4: userData?.pDATASET[0]?.CIRCLE_CODE,
          param5: "",
          param6: "",
        },
        { sid: userData.token }
      );
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
        logOut(response.data); // Run logout function on error
      }
      dispatch({ type: GET_DATA_CUSTOMER, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

// Set customer data
export const getCustomerDetails = (userData, details) => {
  console.log(details);
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      //let response = await serverCall(apis.FETCH_DATA_CATEGORY, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID":4, "param1": 234 ,"param2": 12455, "param3": 0, "param4": "123456", "param5": 123 , "param6": ""}, { "sid": userData.token });
      let response = await serverCall(
        apis.GET_NOTIFICATION_DETAILS,
        "POST",
        {
          userName: userData?.pDATASET[0]?.USERNAME,
          apiID: 2,
          param1: details.customer_id,
          param2: details.meterid,
          param3: 0,
          param4: "",
          param5: "",
          param6: "",
        },
        { sid: userData.token }
      );
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
        logOut(response.data); // Run logout function on error
      }
      dispatch({ type: GET_DATA_CUSTOMER_DETAILS, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

export const setNotificationWithRemark = (userData, data) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      let response = await serverCall(
        apis.NOTIFICATIN_REQUEST,
        "POST",
        { userName: userData?.pDATASET[0]?.USERNAME, apiID: 6, data: data },
        { sid: userData.token }
      );
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
        logOut(response.data); // Run logout function on error
      }
      dispatch({ type: SET_DATA_NOTIFICATION_REMARK, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

export const clearCustomerDetails = (userData) => {
  return async (dispatch) => dispatch({ type: CLEAR_ALL_DATA, payload: [] });
};

export const fetchDataEvent = (userData) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      let response = await serverCall(
        apis.FETCH_DATA_CATEGORY,
        "POST",
        {
          userName: userData?.pDATASET[0]?.USERNAME,
          apiID: 6,
          param1: 0,
          param2: 0,
          param3: 0,
          param4: "",
          param5: "",
          param6: "",
        },
        { sid: userData.token }
      );
      console.log(response, "userName");
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
        logOut(response.data); // Run logout function on error
      }
      dispatch({ type: GET_DATA_EVENT, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

export const getNotificationDetails = (userData, details) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      //let response = await serverCall(apis.FETCH_DATA_CATEGORY, "POST", { "userName": 'WBADMIN', "apiID":5, "param1": details.eventType ,"param2": "2031", "param3": 0, "param4": "03-08-24", "param5": '15-10-24' , "param6": ""}, { "sid": userData.token });
      let response = await serverCall(
        apis.GET_NOTIFICATION_DETAILS,
        "POST",
        {
          userName: userData?.pDATASET[0]?.USERNAME,
          apiID: 9,
          param1: details.eventName,
          param2: details.customerId,
          param3: details.meterId,
          param4: "",
          param5: "",
          param6: "",
        },
        { sid: userData.token }
      );
      dispatch({ type: GET_DATA_CUSTOMER_DETAILS, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

export const ViewNotificationDetailsValue = (userData, details) => {
  console.log(details);
  
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      //let response = await serverCall(apis.FETCH_DATA_CATEGORY, "POST", { "userName": 'WBADMIN', "apiID":5, "param1": details.eventType ,"param2": "2031", "param3": 0, "param4": "03-08-24", "param5": '15-10-24' , "param6": ""}, { "sid": userData.token });
      let response = await serverCall(
        apis.GET_NOTIFICATION_DETAILS,
        "POST",
        {
          userName: userData?.pDATASET[0]?.USERNAME,
          apiID: 10,
          param1: details.eventName || 1,
          param2: details.customerId,
          param3: details.meterId,
          param4: details.toStart,
          param5: details.toEnd,
          param6: "",
        },
        { sid: userData.token }
      );
      dispatch({ type: GET_DATA_CUSTOMER_DETAILS, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};

export const notificationDetails = (
  userData,
  ServiceCategory,
  MeterCategory,
  apiID
) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DATA_REQUEST });
    try {
      //let response = await serverCall(apis.FETCH_DATA_CATEGORY, "POST", { "userName": 'WBADMIN', "apiID":5, "param1": details.eventType ,"param2": "2031", "param3": 0, "param4": "03-08-24", "param5": '15-10-24' , "param6": ""}, { "sid": userData.token });
      let response = await serverCall(
        apis.GET_NOTIFICATION_DETAILS,
        "POST",
        {
          userName: userData?.pDATASET[0]?.USERNAME,
          apiID: apiID,
          param1: ServiceCategory,
          param2: MeterCategory,
          param3: 0,
          param4: "",
          param5: "",
          param6: "",
        },
        { sid: userData.token }
      );
      // logOut(response.data)
      dispatch({ type: _GET_ALL_DETIALS, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_DATA_FAILURE, error: error.message });
    }
  };
};
